import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "alert alert-danger d-flex flex-column align-items-start",
  role: "alert"
}
const _hoisted_2 = { class: "d-flex align-items-center mb-2" }
const _hoisted_3 = { class: "mb-2 error-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[1] || (_cache[1] = _createElementVNode("i", { class: "bi bi-exclamation-triangle-fill me-2" }, null, -1)),
      _createElementVNode("strong", null, _toDisplayString($props.title), 1)
    ]),
    _createElementVNode("p", _hoisted_3, _toDisplayString($props.message), 1),
    ($props.retryable)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          class: "btn btn-sm btn-outline-danger",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('retry')))
        }, [...(_cache[2] || (_cache[2] = [
          _createElementVNode("i", { class: "bi bi-arrow-clockwise ms-1" }, null, -1),
          _createTextVNode(" تلاش مجدد ", -1)
        ]))]))
      : _createCommentVNode("", true)
  ]))
}